<template>

    <label v-bind:class="cssLabel">
        <slot name="label"></slot>
    </label>
    <CustomButton :title="selectedText" class="text-nowrap text-left whitespace-nowrap" predefinedStyle="inputTyp"
        @button:click="open = !open">
        <template #label>
            {{ truncatedText }}
        </template>
    </CustomButton>
    <dropdown-menu v-show="open"
    class="absolute max-h-[64vh] overflow-auto" 
    @menu:select="selectOption($event)"  :menuOptions="possibleSelections"
        :data="{}">

    </dropdown-menu>

</template>
<script>
import _ from 'lodash';
import { useReportingListStore } from '../../pinia/ReportingListStore';
export default {
    props: {
        limit: {
            type: Number,
            default: 20,
        },
        value: {
        },
        columndata: {

        },
        predefinedStyle: {
            type : String,
            default : undefined,
        }
    },
    setup(){
        const ReportingListStore = useReportingListStore();
        return {
            ReportingListStore,
        };
    },
    data() {
        return {
            open: false,
            distincts: [],
        };
    },
    watch: {
        "distinctsMeta" :  {
            handler(newVal){
                if(newVal && this.distincts && newVal.length > this.distincts.length){
                    this.distincts = newVal;
                }
            },
            deep: true,
        }
    },
    mounted(){
        if(this.ReportingListStore?.meta?.distincts ){
            this.distincts = _.get(this.ReportingListStore?.meta?.distincts, this.columndata.key, _.get(this.ReportingListStore?.meta?.distincts, this.columndata.distinct_key, []));
        }
    },
    methods: {
        selectOption(event) {
            var index = this.value.findIndex(item => item == event.value);
            var tmp = this.value;
            if (index > -1) {
                tmp.splice(index, 1);
            } else {
                tmp.push(event.value);
            }
            this.$emit("update:value", tmp);
        }
    },
    computed: {
        distinctsMeta(){
            if(this.ReportingListStore?.meta.distincts && this.columndata?.key){
                return _.get(this.ReportingListStore?.meta?.distincts, this.columndata.key, _.get(this.ReportingListStore?.meta?.distincts, this.columndata.distinct_key));
            }
            return [];
        },
        selectedText() {
            var tmp = "";
            for (let i in this.value) {
                var index = this.possibleSelections.findIndex(item => item.value == this.value[i]);
                if (index > -1) {
                    if (i != 0) {
                        tmp += ", ";
                    }
                    tmp += this.possibleSelections[index].text;
                }
            }
            if (tmp == "") {
                return "None";
            }
            return tmp;
        },
        truncatedText() {
            return _.truncate(this.selectedText, { length: this.limit, omission: " ..." });
        },
        identifer(){
            return this.columndata?.distinct_value ?? "id";
        },
        possibleSelections() {
            var tmp = [];
            if (this.distincts && this.distincts) {
                for (let i in this.distincts) {
                    if(this.distincts[i] && typeof this.distincts[i] == "string"){
                        tmp.push({
                            key: "select",
                            text: this.distincts[i],
                            value: this.distincts[i],
                            icon: (this.value.length > 0 && this.value.includes(this.distincts[i])) ? "far fa-check-square" : "far fa-square",
                        });
                    }
                    if(this.distincts[i] && typeof this.distincts[i] == "object"){
                        let keys = this.columndata.distinct_relation.split(".");
                        tmp.push({
                            key: "select",
                            text: this.distincts[i][keys[1]],
                            value: this.distincts[i][this.identifer],
                            icon: (this.value.length > 0 && this.value.includes(this.distincts[i][this.identifer])) ? "far fa-check-square" : "far fa-square",
                        });
                    }
                }
            }
            return tmp;
        },
        companyTypes() {
            return this.$store.state.companies.companyTypes.list;
        },
        cssLabel: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle]["label"];
            }
            return this.predefinedStyles["default"]["label"];
        },
        cssInput: function () {
            if (this.predefinedStyle !== undefined && this.predefinedStyles[this.predefinedStyle] !== undefined) {
                return this.predefinedStyles[this.predefinedStyle]["input"];
            }
            return this.predefinedStyles["default"]["input"];
        },
        predefinedStyles() {
            return {
                default: {
                    label: "text-base text-stone-900 dark:text-slate-100 font-bold mb-1",
                    input: "w-full text-base outline-none border-2 border-gray-200 dark:border-transparent dark:hover:border-slate-500 dark:focus-visible:border-slate-500 focus-visible:border-accent-color rounded-md py-1.5 px-3 dark:bg-gray-700"
                },
            };
        }
    }
};
</script>
<style scoped></style>
